export default "__VITE_ASSET__C7LYhk0l__"